import { makeAutoObservable } from 'mobx';

class ReviewTypeViewModel {
  description;

  data;
  checked = false;
  uiState;

  constructor({description, info, data, uiState}) {
    makeAutoObservable(this);

    this.data = data;
    this.description = description;
    this.info = info;
    this.uiState = uiState;
  }

  toggle() {
    this.checked = !this.checked;
  }
}

export default ReviewTypeViewModel;
